module.exports = __webpack_public_path__ + "media/images/pc/top/icon-flag-72f3e35340534fcb1d0cd7203565f2e2.svg";